/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RouteApp from './routes/route';
import 'antd/dist/antd.css';
import './App.scss';
import { setToken } from './actions/app';
import { setAuthentication } from './services/api';
import { setUserHeader } from './actions/user';
import { cargarPrivilegiosAlLogin } from './actions/auth';


function App() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userReducer.user);
  const token = useSelector((state) => state.appReducer.token);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    dispatch(
      setToken({
        accessToken,
        refreshToken,
      })
    );
  }, []);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    setAuthentication();
    // Si hay token y usuario autenticado, cargar privilegios
    if (accessToken && user && user._id) {
      dispatch(cargarPrivilegiosAlLogin(user._id));
    } else if (accessToken) {
      // Si solo hay token, refresca el usuario (esto disparará el efecto de abajo)
      dispatch(setUserHeader());
    }
  }, [token, user?._id]);

  return <RouteApp />;
}

export default App;
